import { Blocs } from '@business/blocs';
import { UserId } from '@business/entities/account';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';

export class NylasAccountsBloc extends BaseBloc {
  private readonly userBloc = resolve(Blocs.user);

  constructor(readonly userId: UserId) {
    super();
  }

  readonly user$ = this.userBloc.selectUser(this.userId);

  loading = new LoadingState();

  onInit() {
    return this.userBloc.fetchUserSocials(this.userId).pipe(this.loading.run());
  }

  deleteSocialAccount = this.userBloc.deleteSocialAccount;
  updateSocialSignature = this.userBloc.updateSocialSignature;
}
